import { ClipboardList, Search, MapPinned, FileCheck2 } from "lucide-react";
import { Chapter, FadeUp } from "../Reveal";

const BLOCKS = [
  {
    num: "01",
    icon: ClipboardList,
    title: "Besoin qualifié",
    desc: "Type de chantier, quantités, dimensions, contraintes, localisation et délai.",
    testid: "block-besoin-qualifie",
  },
  {
    num: "02",
    icon: Search,
    title: "Recherche ciblée",
    desc: "Sélection des familles de produits et des solutions adaptées à la demande.",
    testid: "block-recherche-ciblee",
  },
  {
    num: "03",
    icon: MapPinned,
    title: "Commercial terrain",
    desc: "Un commercial reprend votre dossier et peut organiser un rendez-vous ou un déplacement sur site lorsque cela est nécessaire.",
    testid: "block-commercial-terrain",
  },
  {
    num: "04",
    icon: FileCheck2,
    title: "Proposition claire",
    desc: "Une réponse commerciale structurée est préparée selon le besoin validé.",
    testid: "block-proposition-claire",
  },
];

export const Positionnement = () => (
  <section id="approche" data-testid="positionnement-section" className="bg-ivoire py-20 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
      <Chapter num="01" label="Notre approche" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16 lg:mb-20">
        <FadeUp className="lg:col-span-7">
          <h2 className="font-display font-medium text-petrol text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
            Un interlocuteur pour vos approvisionnements.
          </h2>
        </FadeUp>
        <FadeUp delay={0.15} className="lg:col-span-5">
          <p className="text-base text-mute leading-relaxed">
            EQUORIS accompagne les professionnels dans la définition de leurs besoins en
            matériaux de construction et de rénovation et centralise la demande autour d'un
            interlocuteur commercial.
          </p>
        </FadeUp>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {BLOCKS.map(({ num, icon: Icon, title, desc, testid }, i) => (
          <FadeUp key={testid} delay={i * 0.1}>
            <div
              data-testid={testid}
              className="group h-full bg-white rounded-3xl border border-petrol/10 p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-teal/40 hover:shadow-xl hover:shadow-petrol/5"
            >
              <div className="flex items-start justify-between mb-8">
                <span className="w-11 h-11 rounded-t-full rounded-b-xl bg-sagelight flex items-center justify-center transition-colors duration-300 group-hover:bg-teal/15">
                  <Icon className="w-5 h-5 text-teal" />
                </span>
                <span className="font-display italic text-2xl text-petrol/25">{num}</span>
              </div>
              <h3 className="text-lg font-semibold text-petrol mb-3">{title}</h3>
              <p className="text-sm text-mute leading-relaxed">{desc}</p>
            </div>
          </FadeUp>
        ))}
      </div>

      <FadeUp delay={0.1} className="mt-20 lg:mt-28">
        <p
          data-testid="positionnement-objectif"
          className="font-display italic font-medium text-center text-petrol text-2xl sm:text-3xl lg:text-4xl leading-snug max-w-4xl mx-auto"
        >
          « L'objectif : vous faire gagner du temps dans{" "}
          <span className="text-teal">le choix et l'achat</span>. »
        </p>
      </FadeUp>
    </div>
  </section>
);
